import { IChatV2ComponentChunk, IChatV2ExecutionEvent } from '@shared/interfaces/ai-executor.interface';
import { ISendChatMessageResponse } from '../../../../../shared/interfaces/ai-chat.interface';

export interface IChatTextContentItem {
  type: 'text';
  text: string;
}

export interface IChatComponentContentItem extends IChatV2ComponentChunk {
  type: 'ui-component';
}

export type IChatContentItem = IChatTextContentItem | IChatComponentContentItem;

export interface IChatMessage extends ISendChatMessageResponse {
  ratingSubmitted: boolean;
  events?: IChatV2ExecutionEvent[];
  contentBlocks?: IChatContentItem[];
}

export enum AiChatStatus {
  IDLE = 'IDLE',
  LOADING_SESSION = 'LOADING_SESSION',
  WAITING_FOR_STATIC_RESPONSE = 'WAITING_FOR_STATIC_RESPONSE',
  STREAMING_IN_PROGRESS = 'STREAMING_IN_PROGRESS',
}
